import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'

// Siddhartha extras (legacy tbl_news / tbl_notice): sub title, short description, image alt/title.
// Shown only when the backend setting showNewsNoticeExtraFields is '1' (SblWebsiteSettingsSeeder).
export const newsNoticeExtraFieldNames = [
  'sub_title',
  'sub_title_np',
  'short_description',
  'short_description_np',
  'image_alt',
  'image_title',
]

type Props = {
  handleChange: (e: any) => void
  errors: any
  touched: any
  isSingleLanguage?: boolean
}

const fields = [
  {name: 'sub_title', label: 'Sub title (EN)'},
  {name: 'sub_title_np', label: 'Sub title (NP)', np: true},
  {name: 'short_description', label: 'Short description (EN)', textarea: true},
  {name: 'short_description_np', label: 'Short description (NP)', np: true, textarea: true},
  {name: 'image_alt', label: 'Image alt text'},
  {name: 'image_title', label: 'Image title'},
]

const NewsNoticeExtraFields = ({handleChange, errors, touched, isSingleLanguage}: Props) => {
  const show = checkBackendSetting('showNewsNoticeExtraFields')
  if (!show) return null

  return (
    <>
      {fields
        .filter((f) => !(f.np && isSingleLanguage))
        .map((f) => (
          <div key={f.name} className='col-md-6 col-xs-12'>
            <FormTextBox
              type='text'
              as={f.textarea ? 'textarea' : undefined}
              labelClassName='col-md-12'
              containerClassName='col-md-12'
              placeholder={f.label}
              label={f.label}
              name={f.name}
              onChange={handleChange}
              errors={errors}
              touched={touched}
            />
          </div>
        ))}
    </>
  )
}

export default NewsNoticeExtraFields
